/**
 * @desc transform an object to Array
 */
import * as lodash from './lodash';
// tslint:disable
export default function normalizeToArray(obj) {
    return lodash.isArray(obj) ? obj : [obj];
}
